<template>
  <RouterView />
  <OrientationGuard />
</template>

<script setup lang="ts">
import OrientationGuard from './components/OrientationGuard.vue';
</script>
